import { render } from "./RqDiscountModal.vue?vue&type=template&id=89b6a45c"
import script from "./RqDiscountModal.vue?vue&type=script&lang=js"
export * from "./RqDiscountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__